import { render } from "./rebooking.vue?vue&type=template&id=7138322a&ts=true"
import script from "./rebooking.vue?vue&type=script&lang=ts"
export * from "./rebooking.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__